import type { Ref } from 'vue';
import type { ExtendedISbStoryData } from '~/types/storyblokApi';

/**
 * Attach Storyblok bridge updates to an existing story ref.
 * Mutates the passed ref in place to keep the calling component reactive.
 */
export function useStoryblokBridgeRef<T>(story: Ref<ExtendedISbStoryData<T> | null | undefined>) {
    onMounted(() => {
        if (!story.value) return;

        useStoryblokBridge(story.value.id, (newStory) => {
            story.value = newStory;
        });
    });
}
